import { createBrowserRouter, Outlet } from 'react-router-dom';
import { ErrorBoundary } from '@shared/ui';
import { GuidePage } from '@widgets/guide';
import { salesRoutes } from '@sales/app/routes/routeTree';
import { opsRoutes } from '@ops/app/routes/routeTree';
import { catalogRoutes } from '@catalog/app/routes/routeTree';
import { ShellLayout } from '../ShellLayout';
import { LauncherPage } from '@pages/launcher';
import { AdminPage, AdminLayout } from '@pages/admin';
import { UserActivityPage } from '@pages/user-activity';

function RootLayout() {
  return (
    <ErrorBoundary>
      <ShellLayout>
        <Outlet />
      </ShellLayout>
    </ErrorBoundary>
  );
}

/**
 * Wired modules supply their own AppShell chrome, so we mount them directly
 * without the shell's `ShellLayout` wrapper. The launcher keeps the shell
 * chrome.
 */
export const router = createBrowserRouter([
  {
    path: 'sales/*',
    children: salesRoutes('/sales'),
  },
  {
    path: 'ops/*',
    children: opsRoutes('/ops'),
  },
  {
    path: 'catalog/*',
    children: catalogRoutes('/catalog'),
  },
  {
    element: <RootLayout />,
    children: [
      { path: '/', element: <LauncherPage /> },
      { path: '/guide', element: <GuidePage moduleFilter="shell" adminSeesAll allowAdminEdit /> },
      {
        path: '/admin',
        element: <AdminLayout />,
        children: [
          { index: true, element: <AdminPage /> },
          { path: 'activity', element: <UserActivityPage /> },
          { path: 'guide', element: <GuidePage allowAdminEdit /> },
        ],
      },
    ],
  },
]);
